//user side result page - shows result details and answer review


import { useEffect, useState } from "react";
import API from "../services/api";
import { Container, Card, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const ResultPage = () => {
  const [data, setData] = useState(null);
const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
const params = new URLSearchParams(location.search);
const resultId = params.get("id");

  useEffect(() => {
    const fetchData = async () => {
      const fd = new FormData();
      fd.append("session_id", localStorage.getItem("session_id"));
      if (resultId) {
        fd.append("result_id", resultId);
      }
      try {
        // ✅ get result
        const res1 = await API.post("/auth/get-result.php", fd);
        setData(res1.data);
  
        // ✅ get user
        const res2 = await API.post("/auth/get-user.php", fd);
        setUser(res2.data.user);
  
      } catch (err) {
        console.error(err);
      }
    };
  
    fetchData();
  }, []);

  if (!data || !user) return <h4 className="text-center mt-5">Loading...</h4>;

  const result = data?.result;
  const questions = data?.questions || [];
  
  if (!result) {
    return <h4 className="text-center mt-5">No Result Found</h4>;
  }
  
  const answers = JSON.parse(result.answers || "{}");

  const attempted = result.attempted || 0;

  // ✅ overall exam percentage
  const percentage =
    result.total > 0
      ? Math.round((result.score / result.total) * 100)
      : 0;
  
  // ✅ accuracy based on attempted
  const accuracy =
    attempted > 0
      ? Math.round((result.score / attempted) * 100)
      : 0;


    

  return (
    <div className="result-page">

      {/* HEADER */}
      <div className="result-header">
        <Container>
          <div className="d-flex align-items-center gap-4">

            <div className="score-box">
              {percentage}%
            </div>

            <div>
  <h4 className="fw-bold text-white mb-1">
    {user.first_name} {user.last_name}
  </h4>
  <small className="text-light">
    Cyber Security Assessment
  </small>
</div>

          </div>
        </Container>
      </div>

      <Container className="mt-4">

        {/* STATS */}
        <Row className="g-3 mb-4">
          <Col md={4}>
            <Card className="stat-card text-center">
              <h5>{result.score}/{result.total}</h5>
              <small>Score</small>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="stat-card text-center">
            <h5>{attempted}/{result.total}</h5>
            <small>Questions Attempted</small>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="stat-card text-center">
            <h5>{percentage}%</h5>
            <small>Total Exam Percentage</small>
            </Card>
          </Col>
        </Row>

        {/* WARNING */}
        {/* <Card className="warning-card mb-4">
          ⚠ Tab switches detected: {result.tab_switches || 0}
        </Card> */}

        {/* ANSWERS */}
        <Card className="p-4 shadow-sm">
          <h5 className="fw-bold mb-3">Answer Review</h5>

          {questions.map((q, i) => {
  const userAns = answers[q.id];
  const correct = q.correct_answer;

  const isCorrect =
    userAns &&
    userAns.toString().trim().toLowerCase() ===
    correct.toString().trim().toLowerCase();

  return (
    <div key={q.id} className="review-box">

      <p className="fw-bold mb-1">
        Q{i + 1}. {q.question}
      </p>

      {/* ✅ CASE 1: CORRECT */}
      {isCorrect ? (
        <div className="small text-success">
          ✔ Correct: {userAns}
        </div>
      ) : (
        <>
          {/* ❌ CASE 2: WRONG OR NOT ANSWERED */}
          <div className="small text-danger">
            {userAns ? (
              <>❌ Your Answer: {userAns}</>
            ) : (
              <>❌ Not Answered</>
            )}
          </div>

          <div className="small text-success mt-1">
            ✔ Correct: {correct}
          </div>
        </>
      )}

    </div>
  );
})}
        </Card>

        <div className="text-center mt-4">
          <Button
            onClick={() => navigate("/dashboard")}
            className="px-4"
          >
            Back to Dashboard
          </Button>
        </div>

      </Container>

      {/* CSS */}
      <style>{`
        .result-page {
          background: #f5f7fb;
          min-height: 100vh;
        }

        .result-header {
          background: linear-gradient(135deg,#c0392b,#e74c3c);
          padding: 40px 0;
        }

        

        .score-box {
          background: rgba(255,255,255,0.2);
          padding: 20px;
          border-radius: 15px;
          font-size: 32px;
          font-weight: bold;
          color: white;
        }

        .stat-card {
          padding: 20px;
          border-radius: 12px;
        }

        .warning-card {
          padding: 12px;
          background: #fff3cd;
          border-radius: 10px;
        }

        .review-box {
          border: 1px solid #eee;
          padding: 12px;
          border-radius: 10px;
          margin-bottom: 10px;
        }

      `}</style>

    </div>
  );
};

export default ResultPage;